import { FC } from 'react';
import { Actions, Photo } from '#advert/components/card';
import advertCardHeaderCss from '../assets/advert-card-header.module.scss';

const Header: FC = () => (
  <div className={advertCardHeaderCss.advertCardHeader}>
    <Photo />
    <Actions />
  </div>
);

export { Header };
